import { createPortal } from "react-dom";

const Backdrop = ({ open }: { open: boolean }) => {
  const div = document.querySelector("#purchase-backdrop");
  if (!div) return null;
  return createPortal(
    <div
      className={`tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-200 ${
        open ? "tw-opacity-40" : "tw-opacity-0 tw-pointer-events-none"
      }`}
    />,
    div,
  );
};

export default Backdrop;
